import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/product';

export default function Product() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
